import { useEffect, useState } from 'react'

/**
 * Debounces a loading boolean so that skeleton loaders only appear when a
 * fetch takes longer than `delayMs` (default 150 ms). If the load resolves
 * within that window the skeleton never paints, preventing the "flash of
 * skeleton" on cached or sub-150 ms responses.
 *
 * Note: the delay is a debounce, not a motion effect. `prefers-reduced-motion`
 * does not suppress it — users still benefit from the no-flash behaviour.
 */
export function useDelayedLoading(isLoading: boolean, delayMs: number = 150): boolean {
  const [show, setShow] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      setShow(false)
      return undefined
    }
    const handle = window.setTimeout(() => setShow(true), delayMs)
    return () => window.clearTimeout(handle)
  }, [isLoading, delayMs])

  return show
}
